module.exports = __webpack_public_path__ + "img/wait_for_room.14281c88.svg";